import { render, staticRenderFns } from "./roleManageMentAdd.vue?vue&type=template&id=4a7585fa&scoped=true&"
import script from "./roleManageMentAdd.vue?vue&type=script&lang=js&"
export * from "./roleManageMentAdd.vue?vue&type=script&lang=js&"
import style0 from "./roleManageMentAdd.vue?vue&type=style&index=0&id=4a7585fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7585fa",
  null
  
)

export default component.exports